<ng-container *ngIf="isLoading; else viewPricing">
  <div fxLayout="column" fxLayoutAlign="center center" style="height: 100vh">
    <uni-loader></uni-loader>
  </div>
</ng-container>
<ng-template #viewPricing>
  <div class="wrapper">
    <div class="timeline-wrapper" *ngFor="let module of modules; let first=first;">
      <p class="font-md text-right font-bold margin-top-0" style="padding-right:72px;" *ngIf="first">
        {{ registrationLeft }} registration(s) left in this round
        <i class="icon-info" (mouseenter)="tooltipHoverEvent(true)" (mouseleave)="tooltipHoverEvent()"></i>
      </p>

      <div class="content">
        <div *ngIf="first" class="container"></div>
        <div class="timeline">
          <ng-container *ngIf="first">
            <div class="timeline-start-point">
              <p class="text-center">{{ module.min_count }}</p>
            </div>
          </ng-container>

          <ng-container *ngIf="first">
            <div class="active-timeline-end-point"></div>
          </ng-container>

          <div *ngIf="first" class="dynamic-timeline">
            <div class="tooltip" #tooltip>
              <div class="font-xs tooltip-text sparro-grey-800">
                <b>How awards & fees work?</b>
                <p>The fee to participate grows based on the number of registrations received.
                  Similarly, the prize money proportionally grows with rising participating entries.
                  The prize money and fees grow after the end of every registration round
                </p>

                <p>This implies, the sooner you register, the less you will pay as fees.
                  More number of teams you will compete with, the higher the amount of prize you will be entitled to receive.
                </p>
              </div>
            </div>
          </div>

          <mat-card class="dynamic-card" [ngClass]="{'active': first }">
            <div fxLayout="row" fxLayout.lt-sm="column" class="width-100" fxLayoutGap="24px" fxLayoutGap.lt-sm="16px">
              <div fxLayout="column" fxLayout.lt-sm="column" fxFlex="65" fxFlex.lt-sm="100">
                <h3 class="font-md sparro-grey-800 font-bold margin-top-0" [ngClass]="{'sparro-orange-600': first}">
                  {{ first ? 'Current round grants' : 'Next round grants' }}
                </h3>

                <div *ngFor="let prize of module.prizes" fxLayout="row" class="margin-bottom-6" fxLayoutAlign="start start" fxLayoutGap="24px">
                  <uni-image 
                    [src]="prize.image"
                    [default]="defaultImage"
                    [alt]="prize.title"
                    [width]="70"
                    [height]="80"
                    auxClassList="prize-img">
                  </uni-image>
                    <div fxLayout="column" fxLayoutGap="12px">
                      <h4 class="font-md font-bold sparro-grey-900 margin-0">{{ prize.title }}</h4>
                      <h5 class="font-sm font-regular sparro-grey-800 margin-0"> {{ prize.subtitle }} {{ prize.desc }}</h5>
                  </div>
                </div>
              </div>

              <div fxLayout="column" fxFlex="35" fxFlex.lt-sm="100">
                <p class="font-md sparro-grey-800 font-bold margin-top-0" [ngClass]="{'sparro-orange-600': first }">Registration fees</p>
                <div *ngFor="let payment of module.payment_categories" fxLayout="row" class="margin-bottom-6">
                  <div fxLayout="column" fxLayoutGap="12px">
                    <h4 class="font-md font-bold sparro-grey-900 margin-0">{{ payment.title | titlecase }}</h4>
                    <h5 class="font-sm font-regular sparro-grey-800 margin-0">{{ payment.cost }} $ /entry</h5>
                  </div>
                </div>
              </div>
            </div>
          </mat-card>

          <div class="timeline-end-point">
            <p class="text-center">{{ module.max_count }}</p>
          </div>

        </div>
      </div>
    </div>

    <div class="button-container" fxLayout="row" fxLayoutAlign="center center">
      <ng-container *ngIf="isLoadingNext; else viewTemplate">
        <div fxLayout="row" fxLayoutAlign="center center" style="height: 120px">
          <uni-loader></uni-loader>
        </div>
      </ng-container>
      <ng-template #viewTemplate>
        <uni-state-button
          default="Load more"
          button_class="secondary"
          (click)="loadNextDeadlines()"
          *ngIf="next">
        </uni-state-button>
      </ng-template>
    </div>

  </div>
</ng-template>
